"use strict";

exports.__esModule = true;
var _ActionButtonElement = require("./ActionButtonElement");
Object.keys(_ActionButtonElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionButtonElement[key]) return;
  exports[key] = _ActionButtonElement[key];
});
var _ActionButtonThumbnail = require("./ActionButtonThumbnail");
Object.keys(_ActionButtonThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionButtonThumbnail[key]) return;
  exports[key] = _ActionButtonThumbnail[key];
});
var _ActionButtonFields = require("./ActionButtonFields");
Object.keys(_ActionButtonFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionButtonFields[key]) return;
  exports[key] = _ActionButtonFields[key];
});
var _ActionButtonHeader = require("./ActionButtonHeader");
Object.keys(_ActionButtonHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionButtonHeader[key]) return;
  exports[key] = _ActionButtonHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});